import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthPageLayoutComponent } from '../../../shared/layout/auth-page-layout/auth-page-layout.component';
import { SigninFormComponent } from '../../../shared/components/auth/signin-form/signin-form.component';
import { AuthService } from '../../../shared/services/auth.service';
import { TokenExpirationService } from '../../../shared/services/token-expiration.service';

@Component({
  selector: 'app-sign-in',
  imports: [
    AuthPageLayoutComponent,
    SigninFormComponent,
  ],
  templateUrl: './sign-in.component.html',
  styles: ``
})
export class SignInComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private tokenExpirationService = inject(TokenExpirationService);

  ngOnInit(): void {
    if (this.authService.isAuthenticated() && this.authService.isPasswordResetRequired()) {
      this.router.navigate(['/change-password-required']);
      return;
    }

    // Redirect to dashboard if already authenticated
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
      return;
    }

    // Check if redirected due to session expiration
    this.route.queryParams.subscribe(params => {
      if (params['sessionExpired'] === 'true') {
        // Show session expired modal
        setTimeout(() => {
          this.tokenExpirationService.showSessionExpiredModal();
        }, 100);
        // Clean up query parameter
        this.router.navigate(['/signin'], { replaceUrl: true });
      }
    });
  }
}
